export const MEMBER_INDICATOR_LABELS = {
  RETAIL: {
    actorLabel: 'User',
    compositionTitle: 'Sales Composition by Store',
    monthlySalesTitle: 'Sales by Store (Monthly)',
  },
  AVIATION_SERVICES: {
    actorLabel: 'Cashiers',
    compositionTitle: 'Sales Composition by Branch',
    monthlySalesTitle: 'Sales by Branch (Monthly)',
  },
  AIRPORTS: {
    actorLabel: 'Users',
    compositionTitle: 'Sales Composition by Airport',
    monthlySalesTitle: 'Sales by Airport (Monthly)',
  },
  HOSPITALITY: {
    actorLabel: 'Users',
    compositionTitle: 'Sales Composition by Property',
    monthlySalesTitle: 'Sales by Property (Monthly)',
  },
  DESTINATION: {
    actorLabel: 'Users',
    compositionTitle: 'Sales Composition by Destination',
    monthlySalesTitle: 'Sales by Destination (Monthly)',
  },
  TOURISM_DEVELOPMENT: {
    actorLabel: 'Users',
    compositionTitle: 'Sales Composition',
    monthlySalesTitle: 'Sales by Month',
  },
  DEFAULT: {
    actorLabel: 'Users',
    compositionTitle: 'Sales Composition',
    monthlySalesTitle: 'Sales by Month',
  },
};

export const getMemberLabels = (memberCode) => MEMBER_INDICATOR_LABELS[memberCode] || MEMBER_INDICATOR_LABELS.DEFAULT;
